export enum GroupBy {
  family = 'family',
  favorite = 'favorite',
  favoriteDialog = 'favoriteDialog',
  pending = 'pending',
  model = 'model',
  handed = 'handed',
  finished = 'finished',
  archived = 'archived',
  all = 'all',
  publish = 'publish'
}
